import React from 'react'
import SliderPart from './SliderPart'
import BasicFetch from './BasicFetch'

const Main = () => {

  return (
    <>
      <SliderPart />
      <BasicFetch />
    </>
  )
}

export default Main
